export default __webpack_public_path__ + "static/media/portfolio-189.5d619590.jpg";